import React from "react";
import ButtonUnderlined from "Components/Fragment/ButtonUnderlined";
import { Accordion } from "Components/Base/Surfaces/Accordion";
import { ARROW_LEFT } from "Components/Icons";
import Program from "domains/programs/components/Program";
import withLanguageContext from "lib/hocs/withLanguageContext";

const ProgramDetails = ({
  state,
  isManagerOrAdmin,
  personalId,
  languageContext,
  onToggle,
}) => {
  return (
    <div className="padding-10 bgColor-6 animated fadeInDown">
      <div className="toolbar flex align-c">
        <ButtonUnderlined
          onClick={() => onToggle()}
          startIcon={<ARROW_LEFT />}
          label={languageContext("back")}
        />
      </div>
      <Accordion
        defaultExpanded
        detailsText={
          <Program
            programDetails={state.programDetails}
            activityId={state.programActivityId}
            managerView={isManagerOrAdmin}
            personalId={personalId}
          />
        }
        boxShadow
      />
    </div>
  );
};

export default withLanguageContext(ProgramDetails, "ActivityCentre");
